import React from "react";
import "./Header.css";
import companyLogo from "../../../assets/logo.jpg";
import { Link } from "react-router-dom";

const Header = ({ address, connect, renderWalletAddress }) => {
  const buttonTextChange = address ? renderWalletAddress() : "CONNECT WALLET ";
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light bg_nav ">
        <div className="container-fluid pb-3">
          <Link className="navbar-brand text-white" to="/">
            <img
              src={companyLogo}
              classnamename=""
              style={{ width: "90px" }}
              alt=""
            />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse back2"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-4 back px-4">
              <li className="nav-item">
                <Link
                  className="nav-link navbar-links "
                  aria-current="page"
                  to="/"
                >
                  HOME
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link navbar-links" to="/myNft">
                  MY NFT
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link navbar-links "
                  aria-current="page"
                  to="/Trade"
                >
                  TRAIT STORE
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link navbar-links "
                  aria-current="page"
                  to="/Trade"
                >
                  ABOUT
                </Link>
              </li>
            </ul>
            <div className="d-flex">
              <button
                className="px-3 m-3 py-1 text-uppercase connectWalletBtn py-2  fw-bold "
                onClick={connect}
              >
                {buttonTextChange}
              </button>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
